import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useTeamsStore } from "../stores";

export const deleteTeamType = ({ churchId, teamTypeId }) => {
  return axios.delete(`/churches/${churchId}/team-types/${teamTypeId}`);
};

export const useDeleteTeamType = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteTeamTypeModal =
    useTeamsStore.getState().closeDeleteTeamTypeModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("team_types");
      setNotification({
        type: "success",
        message: "Team type deleted successfully!"
      });
      closeDeleteTeamTypeModal();
    },
    ...config,
    mutationFn: deleteTeamType
  });
};
